import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultDealersTransporterData, getDealersTransporterById, updateDealersTransporter, createDealersTransporter } from '@/api/dealers-transporters';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
import { getTransporters } from '@/api/transporters';
import { getDealerById } from '@/api/dealers';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.formData = Object.assign({}, defaultDealersTransporterData);
    this.loading = false;
    this.transporterList = [];
    this.branchId = null;
    this.rules = {
      transporterId: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      },
      freightPerCarton: {
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }
    };
  }
  get lang() {
    return AppModule.language;
  }
  async activated() {
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      await this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultDealersTransporterData);
      this.formData.dealerId = await parseInt(this.$route.params && this.$route.params.dealerId);
    }
    // fetch branch id according to dealer to get respective transporter of branch
    await this.fetchDealerById(this.formData.dealerId);
    // get transporter list
    await this.getTransporterList();
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getDealersTransporterById(id);
      this.formData = data;
      // Just for test
      const title = this.formData.id + '';
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchDealerById(id) {
    const data = await getDealerById(id);
    this.branchId = data === null || data === void 0 ? void 0 : data.branch.id;
  }
  async getTransporterList() {
    try {
      this.transporterList = await getTransporters(getQuery({
        enabled: true,
        branchId: this.branchId,
        filter: {
          enabled: '$eq',
          branchId: '$eq'
        }
      }));
    } catch (error) {
      this.$notify({
        title: 'Error',
        type: 'error',
        message: error.toString()
      });
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.dealer = {
        id: this.formData.dealerId
      };
      this.formData.transporter = {
        id: this.formData.transporterId
      };
      if (this.isEdit) {
        await updateDealersTransporter(this.formData.id, this.formData);
      } else {
        await createDealersTransporter(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Transporter saved',
        type: 'success',
        duration: 2000
      });
      router.push(`/dealers-transporters/list/${this.formData.dealerId}`);
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'DealersTransporterDetail',
  components: {}
})], default_1);
export default default_1;